import api from './config';

export type ReportType =
  | 'EXPIRY'
  | 'ASSIGNED'
  | 'EXPIRED'
  | 'STOLEN';

export interface ReportParams {
  reportType: ReportType;
  fromDate?: string;
  toDate?: string;
}

export const reportApi = {

  downloadPdf: async (params: ReportParams) => {
    const response = await api.get(
      '/api/reports/download/pdf',
      {
        params,
        responseType: 'blob', // 🔥 VERY IMPORTANT
      }
    );
    return response.data;
  },

  downloadExcel: async (params: ReportParams) => {
    const response = await api.get(
      '/api/reports/download/excel',
      {
        params,
        responseType: 'blob',
      }
    );
    return response.data;
  },

};
